import { module } from 'modujs';

const REQUESTS = {
    'today':   'WEEKDAY[ID="1"]',
    'today+1': 'WEEKDAY[ID="2"]',
    'today+2': 'WEEKDAY[ID="3"]',
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.lang = this.getData('lang').toUpperCase()
        this.locationId = this.getData('location-id')

        this.loadData().then(this.populate.bind(this))
    }

    async loadData() {
        if (window.meteoData != null) {
            return
        }

        try {
            const response = await fetch('/weather.php', {
                signal: AbortSignal.timeout(/* 10 seconds */10000),
            })
            const data = await response.text()
            const parser = new DOMParser()
            const xml = parser.parseFromString(data, 'text/xml')
            window.meteoData = xml
        } catch (err) {
            window.meteoData = false
            // throw err
        }
    }

    populate() {
        const locationData = window.meteoData?.querySelector?.(`SITE[LOCATIONID="${this.locationId}"]`)

        this.$('report').forEach((report) => {
            const requestData = locationData?.querySelector?.(REQUESTS[this.getData('request', report)])

            if (requestData) {
                const temp = this.$('temp', report)[0]
                temp.innerText = requestData.getAttribute('HIGH_TEMP')+'°C'

                const icon = this.getMeteoIconByCode(requestData.getAttribute('ICON'))
                if (icon) {
                    const image = this.$('image', report)[0]
                    image.src = `/assets/images/meteo-icons/${icon}.svg`

                    const text = requestData.getAttribute('FORECAST_TEXT_'+this.lang)
                    if (text) {
                        image.setAttribute('alt', text)
                        image.setAttribute('title', text)
                    }
                }
            }

            report.classList.remove('-loading')
        });

        if (window.meteoData?.children?.length) {
            const updateText = document.createElement('p')
            updateText.innerText = this.getData('last-update-text')+' '+(new Date(window.meteoData?.children[0].getAttribute('GENTIME')).toLocaleString())
            this.$('footer')[0].append(updateText)
        }

        this.call('update', null, 'Scroll')
    }

    getMeteoIconByCode(code) {
        code = code.toLowerCase()
        let icon;

        switch (code) {
            case 'g':
            case 'i':
                icon = 'gi';
                break;
            case 'h':
            case 'k':
            case 's':
            case 'u':
                icon = 'hksu';
                break;
            default:
                icon = code;
                break;
        }

        return icon
    }
}
